import React from 'react';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { InternalStandardProps } from '@mui/material';
import { useStyles } from './styles';

type CollapsableListItemProps = {
  open?: boolean;
  title: string;
  disableGutters?: boolean;
  maxHeight?: number;
} & InternalStandardProps<React.HtmlHTMLAttributes<HTMLDivElement>>;

const CollapsableListItem: React.FC<CollapsableListItemProps> = ({
  open,
  title,
  disableGutters,
  maxHeight,
  children,
}) => {
  const [isOpen, setOpen] = React.useState<boolean>(open || false);
  const classes = useStyles();

  React.useEffect(() => {
    setOpen(open || false);
  }, [open]);

  return (
    <div>
      <ListItem
        button
        onClick={() => setOpen((prevState: boolean) => !prevState)}
        disableGutters={disableGutters}
      >
        <ListItemText primary={title} />
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isOpen} classes={{ root: classes.collapseContainer }} style={{ maxHeight }}>
        {children}
      </Collapse>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default CollapsableListItem;
